
import {post, get} from '@/utils/request'


//--------------------订单管理-----------------

//获取订单列表
export function getOrderListReq(data) {
  return post({
    data,
    url: '!Core/Order/~query/CARD_ORDER_INTERNET.LIST'
  })
}

//获取订单列表
export function getOrderListReq2(data) {
  return post({
    data,
    url: '!Core/Order/~query/CARD_ORDER_SCENE.LIST'
  })
}

// 订单发货
export function deliverGoodsReq(data) {
  return post({
    data,
    url: '!Core/Order/~java/NumCardOrder.deliver'
  })
}

// 延长订单收货时间
export function extendReceiptTimeReq(data) {
  return post({
    data,
    url: '!Front/Order/~java/OrderAction.extendReceiptTime'
  })
}

// 关闭订单
export function closeOrderReq(data) {
  return post({
    data,
    url: '!Core/BusiRule/~java/BusiRule.drive'
  })
}

// 获取订单详情
export function getOrderDetailReq(data) {
  return post({
    data,
    url: '!Core/Order/~query/NUM_CARD_ORDER.DETAIL'
  })
}

// 获取订单身份证信息
export function getOrderCertReq(data) {
  return post({
    data,
    url: '!Base/Certificate/~java/Certificate.getByOrderId'
  })
}

// 修改订单价格
export function modifyPriceReq(data) {
  return post({
    data,
    url: '!Core/Order/~query/NUM_CARD_ORDER.ALTER_PRICE'
  })
}

// 修改备注
export function updateNoteReq(data) {
  return post({
    data,
    url: '!Core/Order/~query/NUM_CARD_ORDER.ALTER_NOTE'
  })
}

// 修改物流
export function updateLogisticsReq(data) {
  return post({
    data,
    url: '!Core/Order/~query/NUM_CARD_ORDER.ALTER_EXPRESS'
  })
}

//订单详情-获取物流公司信息
export function getLogisticsReq() {
  return get({
    loading: false,
    url: '!Manage/Express/~java/ExpressManage.getExpressCompanyList'
  })
}

//订单详情-获取物流追踪信息
export function getExpressTracesReq(data) {
  return post({
    data,
    url: '!Partner/Express/~java/BaiduExpress.getTraces'
  })
}
